export default {
  admin_users: [],
  pagination: {},
  admin_user: {}
}
